<template lang="pug">
v-row.question-pairs(v-if="$conf.isMobile")
  v-col
    .pa-4.border.rounded.my-2.full-width(
      v-for="option in leftOptions"
      :key="option.id"
      outlined
    )
      v-menu(
        v-if="!readonly && !pairs[option.id]"
        bottom
      )
        template(#activator="{ attrs, on }")
          .mobile-left-pairs__place-draggable.mr-0(
            :class="[{ active: activePlaceDraggable === option.id, placed: pairs[option.id] }, { 'pointer-events-none': readonly }]"
            v-bind="attrs"
            v-on="on"
          )
            .text-center.pa-2
              v-icon mdi-plus-circle-multiple
              .caption Выберите ответ
        v-list
          v-list-item(
            v-for="answer in rightOptions"
            :key="answer.id"
            @click="choosePair(answer, option.id)"
          )
            v-list-item-title
              ev-image-preview.pa-2(
                v-if="answer.image"
                :src="answer.image.url"
                height="150"
                width="150"
              )
              p(v-else) {{ answer.name }}
      v-card.border.overflow-hidden(
        v-else
        flat
        max-height="190"
        width="100%"
        :disabled="readonly"
      ).ev-card
        v-card-text.d-flex.align-center.justify-center.fill-height.overflow-hidden
          ev-image-preview(
            v-if="pairs[option.id].image"
            gradient="to top right, rgba(255,255,255,0), rgba(255,255,255,.1), white"
            :src="pairs[option.id].image.thumb"
            height="190"
            max-width="100%"
          ).evma-radius
          span(v-else) {{ pairs[option.id].name }}
          v-btn.question-pairs--remove-pair(
            v-if="!readonly"
            icon
            @click="removePair(option.id)"
          )
            v-icon(small) mdi-close-circle
      ev-image-preview.py-3(
        v-if="option.image"
        :src="option.image.url"
        height="180"
        width="100%"
      )
      strong(v-else).pa-3 {{ option.name }}
  v-col(cols=12): slot(:invalid="invalid" :validate="validate")
v-row.question-pairs(v-else)
  v-col.question-pairs__columns.max-width-fit-content
    v-card(
      v-for="option in leftOptions"
      :key="option.id"
      outlined
    ).my-3.ev-card.left-pairs
      .left-pairs__label.flex-grow-1
        ev-image-preview.pa-3(
          v-if="option.image"
          :src="option.image.url"
          height="180"
          width="180"
        )
        strong(v-else).pa-3 {{ option.name }}
      //- @REFACTOR: тут показываю не ответ, а вопрос, потому что дальше ответ дублируется.
      //- пожалуй, стоит отефакторить это, но пока что маленькое обновление в виде хотфикса.
      .left-pairs__answer.pa-2(
        v-if="readonly"
      )
        .d-flex.align-center.justify-center.fill-height(v-if="pairs[option.id] && option.file")
          ev-image-preview(
            v-if="option.file"
            :src="option.file.url"
            height="190"
            max-width="190"
          ).evma-radius
      //- .left-pairs__answer.pa-2(
      //-   v-if="readonly"
      //- )
      //-   .d-flex.align-center.justify-center.fill-height(v-if="pairs[option.id]")
      //-     ev-image-preview(
      //-       v-if="pairs[option.id].file"
      //-       :src="pairs[option.id].file.thumb"
      //-       height="190"
      //-       max-width="190"
      //-     ).evma-radius
      //-     span(v-else) {{ pairs[option.id].name }}
      .left-pairs__place-draggable(
        :class="[{ active: activePlaceDraggable === option.id, placed: pairs[option.id] }, { 'pointer-events-none': readonly }]"
        @drop="addPair($event, option.id)"
        @dragover.prevent="activePlaceDraggable = option.id"
        @dragleave="activePlaceDraggable = null"
      )
        v-card(
          v-if="pairs[option.id]"
          flat
          height="190"
          width="190"
        ).ev-card
          v-card-text.d-flex.align-center.justify-center.fill-height.overflow-hidden
            ev-image-preview(
              v-if="pairs[option.id].image"
              gradient="to top right, rgba(255,255,255,0), rgba(255,255,255,.1), white"
              :src="pairs[option.id].image.thumb"
              height="190"
              max-width="190"
            ).evma-radius
            span(v-else) {{ pairs[option.id].name }}
            v-btn.question-pairs--remove-pair(
              v-if="!readonly"
              icon
              @click="removePair(option.id)"
            )
              v-icon(small) mdi-close-circle

        .text-center(v-else)
          v-icon mdi-plus-circle-multiple
          .caption(v-if="!readonly") Перенесите соответствующий элемент
  v-col(v-if="rightOptions.length").flex-grow-1.question-pairs__columns
    v-slide-x-transition(leave-absolute group)
      v-card.ev-card.my-3.move.scroll-y(
        v-for="option in rightOptions"
        :key="option.id"
        width="200"
        height="200"
        draggable
        :disabled="readonly"
        @dragstart="dragOption = option"
        @dragend="dragOption = null"
        group="pairs"
        outlined
      )
        app-tooltip(
          content-class="redesignPrimaryDarken--text"
          activator-class="d-block"
        )
          template(#reason) Захватите и перенесите этот элемент
          v-card-text
            v-icon(large) mdi-drag-horizontal
            ev-image-preview(
              v-if="option.image"
              :src="option.image.url"
              height="130"
            )
            p(v-else) {{ option.name }}
  v-col(:cols="12")
    slot(:invalid="invalid" :validate="validate")
</template>

<script>
import { shuffle } from 'lodash';

// Сопоставление TYPE = 5
export default {
  name: 'QuestionPairs',
  props: {
    value: { type: Object, default: null },
    question: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      dragOption: null,
      activePlaceDraggable: null,
      pairs: {},
    };
  },
  computed: {
    leftOptions() {
      return this.question.options;
    },
    randomRightOptions() {
      return shuffle(this.leftOptions.map(({ pair }) => pair));
    },
    rightOptions() {
      return this.randomRightOptions.filter(({ id }) => !Object.values(this.pairs).some((i) => i.id === id));
    },
    pairsLength() {
      return Object.keys(this.pairs).length;
    },
    invalid() {
      return this.pairsLength < this.question.options.length;
    },
  },
  watch: {
    pairsLength() {
      const { value } = this;
      const response = { options: [] };
      if (!this.invalid) {
        const serializedPairs = Object.entries(this.pairs).reduce(
          (acc, [optionId, pair]) => [...acc, { pair: [Number(optionId), pair.id] }],
          [],
        );
        response.options = serializedPairs;
      }
      this.$set(value, 'responseValue', {
        ...response,
      });
    },
  },
  created() {
    if (this.value?.responseValue?.options?.length) {
      this.initAnswer();
    }
  },
  methods: {
    initAnswer() {
      this.pairs = this.value?.responseValue?.options?.reduce((acc, { pair: [firstId, secondId] }) => {
        const pair = this.rightOptions.find(({ id }) => id === secondId);
        return {
          ...acc,
          ...pair ? {
            [firstId]: pair,
          } : {},
        };
      }, {});
    },
    addPair(_, optionId) {
      if (!this.pairs[optionId]) {
        this.$set(this.pairs, optionId, this.dragOption);
      }
      this.activePlaceDraggable = null;
    },
    choosePair(target, source) {
      if (!this.pairs[source]) {
        this.$set(this.pairs, source, target);
      }
    },
    removePair(optionId) {
      this.$delete(this.pairs, optionId);
    },
    validate() {
      return !this.invalid;
    },
  },
};
</script>

<style lang="scss" scoped>
.question-pairs {
  &--remove-pair {
    position: absolute;
    top: 0;
    right: 0;
  }

  .active {
    opacity: 0.5;
    transform: scale(1.02);
  }
  .placed {
    border: none !important;
  }

  .question-pairs__columns {
    max-height: 90vh;
    overflow-y: auto;
  }
}
.left-pairs {
  width: 400px;
  display: flex;

  &__label {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    width: 200px;
  }

  &__place-draggable {
    border-radius: 3px;
    padding: 3px;
    height: 200px;
    width: 200px;
    border: 2px dashed #{$accent};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease-in-out;
  }
}

.mobile-left-pairs {
  width: 400px;
  display: flex;

  &__label {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    width: 200px;
  }

  &__place-draggable {
    border-radius: 3px;
    padding: 3px;
    border: 2px dashed #{$accent};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.2s ease-in-out;
  }
}
</style>
